import { render, staticRenderFns } from "./AdminCreateSaleView.vue?vue&type=template&id=6f565a04&scoped=true"
import script from "./AdminCreateSaleView.vue?vue&type=script&lang=js"
export * from "./AdminCreateSaleView.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateSaleView.vue?vue&type=style&index=0&id=6f565a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f565a04",
  null
  
)

export default component.exports